export enum SuicidalityEmailsDataIndex {
  'email' = 'email',
  'updated_at' = 'updated_at',
  'created_at' = 'created_at',
}
